import { registerNotificationResourceRoute } from '@/composables/useNotificationResourceRoutes'

// Opening a watch notification lands on that watch's detail route.
registerNotificationResourceRoute('signal_watch', (notification) => ({
    name: 'signal-watch-show',
    params: { watchId: notification.resource_id },
    query: { 'signal-watch': 'true' },
}))
